import Toast from 'Components/toast-messager'
import Cookies from '@arsenal/arsenal/modules/Cookies'
import getUrl from 'lib/url'
import fetch from 'lib/decorated-fetch'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'

// 举报评论用户
export function reportUser(
  commentId: string,
  reportTypes: string,
  description = '',
  reportUserId?: number | string,
  userId?: string
) {
  const web_id = Cookies('tt_webid') || ''
  const formData = new FormData()
  formData.append('description', description)
  formData.append('comment_id', commentId)
  formData.append('source', '204')
  formData.append('report_types', reportTypes)
  formData.append('app_key', 'auto_web_pc-web')
  formData.append('aid', '1839')
  formData.append('app_name', 'auto_web_pc')
  formData.append(
    'device_id',
    typeof web_id === 'object' ? JSON.stringify(web_id) : web_id
  )
  if (userId) {
    formData.append('user_id', String(userId))
  }
  reportUserId && formData.append('report_user_id', String(reportUserId))
  fetch(getUrl('/api/feedback/v1/report_comment/'), {
    method: 'POST',
    body: formData,
  })
    .then((res: any) => {
      const { err_code } = res
      console.log(res, err_code)
      if (err_code !== 0) {
        Toast.show({
          text: '举报失败',
        })
        return
      }

      Toast.show({
        text: '举报成功',
      })
    })
    .catch((e) => {
      console.log(e)
    })
}

export interface IReportParams {
  objectType:
    | 1 // 评论
    | 5 // 文章
    | 11 // 用户
  objectId?: string
  authorId?: string
  userId?: string
  description?: string
  reportType?: number
  source?: number
}

export function report({
  objectId,
  objectType,
  authorId,
  reportType,
  source,
  description,
  userId,
}: IReportParams) {
  const web_id = Cookies('tt_webid') || ''

  const params = {
    // biz_id: 1839,
    reported_obj_id: objectId,
    reported_obj_type: objectType,
    report_type: reportType,
    source,
    author_id: authorId,
    description,
    user_id: userId,
    device_id: typeof web_id === 'object' ? JSON.stringify(web_id) : web_id,
    app_id: 1839,
    app_name: 'auto_web_pc',
  }

  return fetch('/user/report/add_report', {
    method: 'POST',
    headers: {
      'tt-anti-token': window.localStorage.getItem('tt-anti-token') || '',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: serializeObject(params),
  })
}
